// extracted by mini-css-extract-plugin
export default {"modal_wrap":"ModalBox_modal_wrap__rENCZ","modal_box":"ModalBox_modal_box__DuL+p","check_link":"ModalBox_check_link__2CTT8"};